import { ILanguage } from "../types";

export const en: ILanguage = {
  translation: {
    root: {
      customize: "Customize",
      businessAccount: "Business Account",
      verificationStatus: "Verification Status",
      unableToLoginViaSSO: "We were unable to sign you in via SSO. Please try again or use your email and password.",
      companyInformation: "COMPANY INFORMATION",
      note: "Note",
      businessName: "Business Name",
      enterBusinessName: "Enter Business Name",
      registrationNumber: "Company Reg. No.",
      registrationNumberPlaceholder: "Enter Registration Number",
      taxVat: "Tax/VAT Registration No.",
      vatPlaceholder: "Enter Tax/VAT Registration Number",
      registeredAddress: "Registered Address",
      tradingAddress: "Trading Address",
      sameAsRegisteredAddress: "Same as Registered Address",
      billingInformation: "Billing Information",
      billingPhoneNo: "Billing Phone No.",
      phonePlaceholder: "Enter phone number",
      billingEmail: "Billing Email",
      emailPlaceholder: "Enter Billing Email",
      driverDetails: "Driver Details",
      customerVerificationStatus: "Customer Verification Status",
      enterNationalInsuranceNumber: "Enter National Insurance Number",
      enterYourProfession: "Enter Your Profession",
      enterDriving: "Enter Driving",
      profileImage: "profile image",
      number: "Number",
      image: "Image",
      uploadBack: "Upload back",
      uploadFront: "Upload front",
      issuedBy: "Issued By",
      document: "Document",
      selectDocument: "Select Document",
      addFile: "Add File",
      noDataFound: "No data found",
      noDocumentsFound: "No documents found",
      documentUpdatedAt: "Document Updated at",
      editExpiryDate: "Edit Expiry Date",
      selectExpiryDate: "Select expiry date",
      selectExpiryDateUpload: "Please select an expiry date before uploading.",
      status: "Status",
      images: "Images",
      profession: "Profession",
      nationality: "Nationality",
      driving: "Driving",
      listOfDocumentsUploaded: "List of Documents Uploaded",
      listOfRequiredDocumentsUploaded: "List of Required Documents Uploaded",
      documentType: "Document Type",
      documentName: "Document Name",
      expiryDate: "Expiry Date",
      confirmDelete: "Confirm Delete",
      actions: "Actions",
      completed: "Completed",
      pending: "Pending",
      documentDeleteConfirmMsg:
        "Are you sure you want to delete this document?",
      address: "Address",
      useRegisteredAddress: "Use Registered Address",
      billingEmailAddress: "Billing Email Address",
      billingEmailLabel: "Billing Email Address",
      accountNumber: "Account Number",
      firstName: "First Name",
      lastName: "Last Name",
      firstNameLabel: "First Name",
      lastNameLabel: "Last Name",
      contactEmail: "Contact Email Address",
      emailLabel: "Email Address",
      contactPhone: "Contact Phone No.",
      registeredAddressCaps: "REGISTERED ADDRESS",
      tradingAddressCaps: "TRADING ADDRESS",
      billingInformationCaps: "BILLING INFORMATION",
      customerContactCaps: "CUSTOMER CONTACT",
      contactEmailInvalid: "Please enter a valid Contact email.",
      typeAddress: "Type Address",
      taxFees: "Taxes & Fees",
      vatTax: "VAT/TAX",
      registrationNum: "Registration Number",
      drivingLicenceNumber: "Driving Licence Number",
      invalidPhoneNumber: "Invalid phone number",
      onStartEmail: "We have emailed you on how to get started.",
      emailNotSeen:
        'If you do not see the email in a few minutes, check your "Junk mail" or "spam folder".',
      registerNow: "Register Now",
      email: "Email",
      thankYou: "Thank you",
      pickUpLocation: "Pick-Up Location",
      returnLocation: "Return Location *",
      pickUpDate: "Pick-Up Date *",
      pickUpTime: "Pick-Up Time *",
      invalidPickupLeadTime: "Selected pickup date/time is outside the allowed booking window",
      dropOffDate: "Drop-off date *",
      searchVehicles: "Search Vehicles",
      chooseLocation: "Enter a location or post code",
      vehicleGallery: "Vehicle Gallery",
      availableOffers: "Available Offers",
      off: "off",
      copyCode: "Copy code",
      privacyPolicy: "Privacy Policy",
      termsAndConditions: "Terms and Conditions",
      dropOffTime: "Drop-off Time *",
      noVehiclesFound: "No vehicles found matching the selected criteria",
      noRecordFound: "Sorry, no matching records found!",
      vehicles: "Vehicles",
      endDate: "End Date",
      startDate: "Start Date",
      past: "Past",
      search: "Search",
      upcoming: "Upcoming",
      current: "Current",
      all: "All",
      more: "More",
      toBeAssigned: "To be assigned",
      ref: "ref",
      reservation: "Reservation",
      booking: "Booking",
      pricingSummary: "Pricing Summary",
      bookingSummary: "Booking Summary",
      subscriptionVehicle: "Subscription Vehicle",
      insurance: "Insurance",
      addons: "Add-ons",
      protectionPlan: "Protection Plan",
      initialRental: "Initial Rental Payment",
      enrollmentFee: "Enrollment Fee",
      quantity: "Quantity",
      subscriptionPrice: "Subscription Price",
      weekly: "Weekly",
      monthly: "Monthly",
      on: "On",
      numberOfDoors: "Number Of Doors",
      numberOfSeats: "Number Of Seats",
      transmission: "transmission",
      fuelType: "Fuel Type",
      week: "Week",
      day: "Day",
      hour: "Hour",
      month: "Month",
      gropu1Icon: "group1 icon",
      vatInclusive: "VAT INCLUSIVE",
      vat: "VAT",
      rental: "Rental",
      speedometer: "speedometer",
      available: "Available",
      priceLowToHigh: "Price low to high",
      priceHighToLow: "Price high to low",
      weHaveSmartCars: "We have smart cars",
      keylessSupport: "We provide keyless entry support with our smart cars",
      keylessVehicles: "Show Keyless Vehicles",
      duration: "Duration",
      swapsAllowed: "Swaps Allowed",
      enrollmentAmount: "Enrollment Amount",
      subscriptionAmount: "Subscription Amount",
      mileageLimit: "Mileage Limit",
      unlimited: "Unlimited",
      weeks: "Weeks",
      months: "Months",
      pricePerExtraMile: "Price per extra mile",
      insurancePolicy: "Insurance Policy",
      removeSubscription: "Remove Subscription",
      noGroupFound: "No groups found with matching criteria!",
      vehicleTypeIcon: "vehicle type icon",
      min: "Min",
      selected: "Selected",
      vehiclesSelected: "Vehicles selected",
      selectVehicles: "Select Vehicles",
      personalDetails: "Personal Details",
      selectAddons: "Select Add-ons",
      continue: "Continue",
      locationSurcharge: "Location Surcharge",
      onTotalRentalAmount: "On Total Rental Amount",
      oneWayFee: "One Way Fee",
      oneWayRentalCharge: "One Way Rental Charge",
      total: "Total",
      firstMonthTotal: "First Month Total",
      firstWeekTotal: "First Week Total",
      depositPayable: "Deposit (Payable at the time of collection",
      deposit: "Deposit",
      insuranceCaps: "INSURANCE",
      customAddon: "custom addon",
      chooseAPolicy: "Choose a policy",
      rate: "Rate",
      typeOfValet: "Type Of Valet",
      nonNegotiable: "Non Negotiable",
      selectValet: "Select Valet",
      collectionAddress: "Collection Address",
      remove: "Remove",
      deliveryAddress: "Delivery Address",
      additionalInformation: "Additional Information",
      confirmBooking: "Confirm Booking",
      proceed: "Proceed",
      getQuote: "Get Quote",
      for: "for",
      agreeWithTermsAndConditions: "I agree with the terms and conditions",
      selectCostCenter: "Select Cost Center For Booking",
      action: "Action",
      name: "Name",
      enterDrivingLicenceNumber: "Enter Driving Licence Number",
      enterLastName: "Enter last name",
      enterFirstName: "Enter first name",
      middleName: "Middle Name",
      middleNameLabel: "Middle Name",
      enterMiddleName: "Enter Middle Name",
      enterYourMail: "Enter your email",
      emailAsterisk: "Email*",
      quoteGeneratedCaps: "QUOTE GENERATED",
      updated: "updated",
      rentalCharges: "Rental Charges",
      totalPayableAmount: "Total payable amount",
      payMinimumAmount: "Pay minimum amount",
      dueAmountPaidWhilePickup: "Due amount to be paid at the time of pickup",
      payOnCollection: "Pay on collection",
      CardAuthorization:
        "Card will be authorised now but amount will be deducted when",
      starts: "starts",
      confirm: "Confirm",
      payAtTimeOfPickup: "now and pay at the time of pickup",
      payFullAmountNow: "Pay full amount now",
      payFullAmountRightAway: "Pay full amount right away",
      FutureChargesRelatedToOngoingBooking:
        "Future charges related to the ongoing booking will be charged to this payment method",
      saveThisCardForFutureInvoices:
        "Save this card to make payment for future invoices on this {{bookingSyntax}}",
      payLater: "Pay Later",
      creditLimitAssigned:
        "Credit limit assigned for this business will be used for this payment",
      CreditsAgainstBooking: "Credits will be used against this booking",
      useCreditNoteBalance: "Use Credit Note Balance",
      telNo: "Tel. No.",
      vatNo: "VAT No.",
      customer: "Customer",
      emailAddress: " Email Address",
      phoneNumber: "Phone Number",
      dateCreated: "Date Created",
      poNumber: "PO Number", //check for full Form
      dateTime: "Date & Time",
      dropOffLocation: "Drop-off Location",
      contractHire: "Contract Hire",
      subscription: "Subscription",
      charges: "Charges",
      enrollmentFees: "Enrollment Fees",
      na: "N/A",
      grandTotal: "Grand Total",
      rentalPrice: "Rental Price",
      daysProRated: "days pro-rated",
      locationSurcharges: "Location Surcharges",
      ofTotalRentalAmount: "of total rental amount",
      nextBilling: "Next Billing",
      subTotal: "Sub Total",
      discount: "Discount",
      discountedPrice: "Discounted Price",
      description: "DESCRIPTION",
      descriptionLabel: "Description",
      thisIsA: "This is a",
      exemptedBooking: "exempted booking",
      thisIstestCourtsey: "This is a test/courtesy",
      isCalculatedAgainst: "is calculated against",
      priceAndSelectedAddons:
        "Price and some selected Add-Ons Excluding Insurance and Deposit",
      recurringWeeklyMonthlyInvoice:
        "A recurring weekly/monthly invoice will be generated automatically for the next week/month.",
      additionalNote: "Additional Note",
      payableAtVehicleCollection: "Payable at the time of vehicle collection",
      purchaseOrderUpdated: "purchase order number updated successfully",
      proceedToPay: "Proceed to pay",
      couponCode: "Coupon Code",
      couponDiscount: "Coupon Discount",
      applyCoupon: "Apply",
      removeCoupon: "Remove coupon",
      enterCouponCode: "Enter coupon code",
      couponApplied: "Coupon applied successfully",
      couponAppliedLabel: "Coupon applied",
      couponRemoved: "Coupon removed",
      discountAndOffers: "Discount & Offers",
      availableCoupons: "Available Coupons",
      checkingAvailableCoupons: "Checking available coupons...",
      noCouponsAvailable: "No coupons are currently available for this booking",
      couponBlockedByDiscount: "A discount has already been applied to this booking. Coupons can't be combined with an existing discount.",
      off: "off",

      searchResults: "Search Results",
      subscriptions: "Subscriptions",
      contractHireVehicleWeeklyMonthly:
        "Contract Hire vehicle for weekly/monthly",
      subscribeVehicleWeeklyMonthly: "Subscribe vehicle for weekly/monthly",
      contractNow: "Contract Now",
      subscribeNow: "Subscribe Now",
      backToBookingCategorySelection:
        "Go back to booking categories selection.",
      accountVerification: "Account Verification",
      profileNotVerifiedMessage:
        "Your profile has not been verified. Kindly contact your operator to complete the account verification process and proceed further.",
      update: "Update",
      reference: "Reference",
      companyRegistrationNumber: "Co Reg No",
      availableFrom: "Available From",
      paellaDish: "Paella dish",
      vehicleCatalogues: "Vehicle Catalogues",
      vehicleDetails: "Vehicle Details",
      verification: "Verification",
      protectionPlans: "Protection Plans",
      authorisedSignatory: "Authorised Signatory",
      item: "Item",
      price: "Price",
      unitPrice: "Unit Price",

      vehicleSpecification: "Vehicle Specification",
      model: "Model",
      color: "Color",
      bodyType: "Body Type",
      tankCapacity: "Tank Capacity",
      interiorColor: "Interior Color",
      seats: "Seats",
      doors: "Doors",
      whatsIncluded: "What's included",
      timeVehicleSwap: "time vehicle swap",
      contractualDetails: "Contractual details",
      longerSubscribeSaveMore:
        "The longer you subscribe for, the more you can save",
      tailorSubscriptionToNeeds:
        "Tailor your subscription to your specific needs",
      easyManagementOnline: "Manage seamlessly and easily online",
      SwapCarAndCancel: "Swap your car if you want or cancel at any time",
      customizeYourContract: "Customize your contract",
      selectPlan: "Select Plan",
      selectTenure: "Select Tenure",
      tentativeStartDate: "Tentative start date",
      selectDate: "Select Date",
      selectTime: "Select Time",
      contractSummary: "Summary of your contract",
      subscriptionChargesLabel: "Subscription Charges",
      initialRentalPayment: "Initial Rental Payment",
      continueToPersonalDetails: "Continue To Personal Details",
      noAvailableAddonsFound:
        "No available add-ons found matching your search criteria",
      nationalInsuranceNumber: "National Insurance Number",

      updateQuote: "Update Quote",
      driverNotAvailable:
        "Driver is not available please contact to rental operator",
      selectDeliverySlot: "Select Delivery Slot",
      wantDelivered: "Do you want it to be delivered?",
      verifyYourLicenceCaps: "VERIFY YOUR LICENCE",
      validateAllFieldsForLicenceCheck:
        " Please validate or enter following details to proceed for licence check. All fields are mandatory",
      postCode: "Post Code",
      thisAgreementAllows: "This agreement allows",
      leftoverAgreement:
        "and our insurance partner to carry out checks on your driving licence and pass the data provided by you to insurers and other related thirdparties (Coastr) for the administration of your vehicle rental, insurance policy, etc. Do you accept and consent to the above?",
      verifyLicence: "Verify Licence",
      licenceCheckingInProgress: "Licence Checking In Progress",
      checkingInProgress:
        "It may take up to 2 minutes, please wait and do not refresh or close your browser",
      licenceCheckingFailed: "Licence Checking Failed",
      checkForCorrectDetails:
        "Please check if you have entered the correct details.",
      tryAgainLater: "If the issue still persists please try again later.",
      licenceCheckedSuccessfully: "Licence Checked Successfully",
      licenceSummaryAdded: "Licence Summary added to customer record",
      creditScore: "Credit Score",
      lastChecked: "Last Checked",
      recheckCreditScore: "RECHECK CREDIT SCORE",
      checkCreditScore: "CHECK CREDIT SCORE",
      proceedToPayment: "Proceed to payment",

      paymentOverview: "Payment Overview",
      schedule: "Schedule",
      contractDetails: "Contract details",
      plan: "Plan",
      swaps: "Swaps",
      payableDeposit: "Payable Deposit",
      customerVerification: "Customer Verification",
      provideAdditionalDetails:
        "Please provide the following additional details within the account section in order to create booking",
      profilePhoto: "Profile Photo",
      submitYourRequest:
        "Once done, please submit your request for approval by clicking on the submit button below",
      submit: "submit",

      uploadLicenceImages: "Upload Licence Images",
      add: "Add",
      uploadFrontBackLicence:
        " Upload front and back image of Licence. Supported file format: .png, .jpeg, .jpg!",
      uploadLicenceImage: "Upload Licence Image",
      authority: "Authority",
      drivingLicenceExpiryDate: "Driving Licence Expiry Date",
      licenceNumber: "Licence Number",
      preview: "Preview",
      addOn: "Add-On",
      contact: "Contact",

      selectSlot: "Select Slot",
      deliveryType: "Delivery Type",
      experience: "Experience",
      type: "Type",
      bookATestDrive: "Book A Test Drive",
      selectASlot: "Select A Slot",
      selectDateTimeSlot: "Select Date and Time Slot",
      vehicleNotAvailable: "Vehicle Not Available for Selected Date",
      selectDifferentDate: "Please Select a Different Date",
      selectCar: "Select A Car",
      availableNow: "Available Now",
      new: "New",
      phone: "Phone",
      customerDetails: "Customer Details",
      dealershipAddress: "Dealership Address",
      dealership: "Dealership",
      bookingTime: "Booking Time",
      bookingType: "Booking Type",
      details: "Details",
      your: "Your",
      confirmation: "Confirmation",
      selectDealership: "Select A Dealership",
      testDriveRequested: "Test Drive Requested",
      testDrive: "Test Drive",
      mobileNumber: "Mobile Number",
      drivingLicenseNumber: "Driving {{licenceSyntax}} Number",
      enterLicenseNumber: "Enter License Number",
      requestTestDrive: "Request Test Drive",
      slot: "Slot",
      vehicle: "Vehicle",

      selectSubsctiption: "SELECT SUBSCRIPTION",
      pricesShownOnSelectedDuration:
        "Prices shown is based on selected duration",
      priceComparison: "Price Comparison",
      oneTime: "One Time",
      subscriptionStartsAt: "Subscription starts at",
      paymentProcessing: "Payment Processing",
      pleaseWait: "Please Wait",
      paymentComplete: "Payment Complete",
      paymentInProgress: "Payment in progress",
      atleastUploadOne: "At least upload one",
      upload: "Upload",
      uploadServiceNotAvailable: "Upload service not available. Please try again.",
      uploading: "Uploading...",
      atDealership: "At Dealership ",
      atHome: "At Home",

      enterYourEmailPassword: "Enter your email and password to login",
      enterMailHere: "Enter your email here",
      required: "Required",
      password: "Password",
      reset: "reset",
      otpForPasswordReset:
        "You will receive an OTP for password reset on your email",
      sendOtp: "send OTP",
      loginInstead: "Login instead",
      verifyOtp: "Verify OTP",
      otp: "OTP",
      otpSentToEmail: "The OTP has been sent to your email",
      enterOtp: "Enter OTP",
      enterOtpHere: "Enter OTP here",
      verify: "Verify",
      setNewPassword: "Set new password",
      eightCharLong: "Must be 8 characters long",
      reenterPassword: "Re-enter password here",
      signInAs: "Sign in as",
      as: "As",
      selectAccountToProceed: "Select an account to proceed",
      personalAccount: "Personal account",
      asBusinessCustomer: "As bussiness customer",
      asDriver: "As driver",
      enterPassword: "Enter password here",
      registerAs: "Register As",
      individual: "Individual",
      business: "Business",
      operatorMandatedCustomerCheck:
        "The Operator has mandated a customer check before you can have a confirmed booking. Please wait for approval, and you will be notified of the same",
      createAccount: "Create Account",
      emailedHowToGetStarted: "We have emailed you on how to get started.",
      ifDontSeeEmail:
        "If you do not see the email in a few minutes, check your 'Junk mail' or 'spam folder'.",
      previousVehicleDetails: "Previous Vehicle Details",
      registration: "Registration",
      makeModel: "Make/Model",
      vin: "VIN",
      driverAssigned: "Driver Assigned",
      currentVehicleDetails: "Current Vehicle Details",
      priceGroup: "Price Group",
      unlimitedMileage: "Unlimited Mileage",
      paymentStatus: "Payment Status",
      invoiceNumber: "Invoice Number",
      deliveryDetails: "Delivery Details",
      collectionDetails: "Collection Details",
      coiDetails: "COI Details",
      policyName: "Policy Name",
      planName: "Plan Name",
      policyNumber: "Policy Number",
      provider: "Provider",
      vehicleSwapDetails: "Vehicle Swap Details",
      swapMyCar: "Swap My Car",
      NoOfSwapsAllowed: "No. of swaps allowed",
      NoOfSwapsAvailed: "No. of swaps availed",
      NoOfSwapsRemaining: "No. of swaps Remaining",
      swapRequestHistory: "SWAP REQUEST HISTORY",
      requestedOn: "REQUESTED ON",
      swapDate: "SWAP DATE",
      oldVehicle: "Old Vehicle",
      newVehicle: "New Vehicle",
      addonsDetails: "Add-ons Details",
      paymentDetails: "Payment Details",
      billingPeriod: "Billing Period",
      creationDate: "Creation Date",
      invoiceType: "Invoice Type",
      regular: "Regular",
      depositDetails: "Deposit Details",
      amount: "Amount",
      totalPaidAmount: "Total Paid Amount",
      cancellationCharges: "Cancellation Charges",
      totalRefundAmount: "Total Refund Amount",
      anUnpaid: "an unpaid",
      aPartiallyPaid: "a partially paid",
      thisIs: "This is",
      pleaseContactUs: "Please contact us for further inquiries",
      reasonToCancelTheBooking: "Please select a reason to cancel the booking",
      enterTheReason: "Enter the reason",
      dismiss: "Dismiss",
      selectVehicle: "Select Vehicle",
      bookingConfirmationInProgress: "Booking confirmation in progress",
      pleaseProvideTheReason: "Please provide the reason",
      quote: "Quote",
      management: "Management",
      pickupDateTimePassed:
        "Either pickup date and time has passed! or it is a zero charge ",
      profileRejectedOrPending:
        "Your profile has either been rejected or in pending status",
      testDriveAgreement: "Test Drive Agreement",
      rentalAgreement: "Rental Agreement",
      contractHireAgreement: "Contract Hire Agreement",
      subscriptionAgreement: "Subscription Agreement",
      extendBooking: "Extend Booking",
      extendBookingDescription: "Choose a new return date and time. If the vehicle is available, your booking will be extended immediately.",
      newReturnDate: "New return date",
      newReturnTime: "New return time",
      requestExtension: "Request Extension",
      extensionConfirmedMessage: "Your booking has been extended to {{date}}.",
      // NU-12870 QA fix: never names the conflicting booking - the customer has no reason
      // to know it exists, and it may belong to someone else entirely.
      extensionConflictMessage: "The vehicle is already booked for another rental during this period, so we can't extend automatically. We've sent your request to the rental operator - your original return date and time still apply until they confirm.",
      // NU-12537: shown instead of extensionConflictMessage when a real available window
      // exists before the conflict - gives the customer the actual achievable date so they
      // can decide whether to wait for staff or request that shorter period themselves.
      extensionConflictMessageWithBoundary: "The vehicle is available for extension only until {{date}}. We've sent your original request to the rental operator - or you can request an extension up to {{date}} yourself right now. Your original return date and time still apply until one of these is confirmed.",
      // NU-12537 QA fix: the disabled Extend Booking button used to show this generic
      // "pending review" wording regardless of why - but the only way an extension ever
      // stays in QUOTE status long enough for the customer to see this tooltip is the
      // vehicle-conflict path (Case C in consumerRequestBookingExtension): the vehicle
      // wasn't available for the requested dates, so it couldn't be confirmed
      // automatically and is waiting on staff. Mirrors the wording already shown in
      // ExtendBookingDialog's own result view right after submitting, for consistency.
      // Deliberately never names the other booking - this customer has no reason to know
      // it exists, and it may belong to someone else entirely.
      extensionAlreadyPending: "Your last extension request couldn't be confirmed automatically because the vehicle is already booked for another rental during this period. Our team is reviewing it and will be in touch.",
      notifications: "Notifications",
      noNotifications: "You have no notifications yet",
      zeroChargeBooking:
        "Zero charge booking can only be confirmed by rental operator",
      pickupDateTimeInPast: "Pickup date and time is in past",
      creditNoteSummary: "Credit Note Summary",
      customerName: "Customer Name",
      customerEmail: "Customer Email",
      creditNoteRef: "Credit Note Ref",
      invoiceRef: "Invoice Ref",
      totalAmount: "Total Amount",
      amountAdjustedRefunded: "Amount Adjusted/Refunded",
      amountAvailable: "Amount Available",
      adjustments: "Adjustments",
      particulars: "particulars",
      adjustedToInvoice: "Adjusted To Invoice",
      adjustedAt: "Adjusted At",
      creditNotes: "Credit Notes",
      availableBalance: "Available Balance",
      searchCreditNoteId: "Search Credit Note Id",
      active: "Active",
      exhausted: "Exhausted",
      creditNoteId: "Credit Note Id",
      dateGenerated: "Date Generated",
      amountRefunded: "Amount Refunded",
      amountRemaining: "Amount Remaining",
      dashboard: "Dashboard",
      activeVehiclesCount: "Active Vehicles Count",
      totalActiveBookings: "Total active Bookings",
      totalVehicles: "Total Vehicles",
      vehicleChecks: "Vehicle checks",
      inProgressBookings: "In-progress bookings",
      vehicleChecksCompleted: "Vehicle checks completed",
      vehicleChecksPending: "Vehicle checks pending",
      dailyBalance: "Daily Balance",
      totalOutstanding: "Total outstanding",
      UnpaidInvoices: "No. of unpaid invoices",
      regularInvoices: "Regular invoices",
      sundryInvoices: "Sundry invoices",
      addNewDriver: "Add new driver",
      phoneNo: "Phone No.",
      drivingLicenceImage: "Driving Licence Image",
      licenceIssuedBy: "{{licenceSyntax}} Issued By",
      licenceExpiryDate: "{{licenceSyntax}} Expiry Date",
      drivingLicenceIssueDate: "Driving Licence Issue Date",
      pcoIssueDate: "Driver PCO Licence Issue Date",
      dateOfBirth: "Date of Birth",
      taskDetailsNotFound: "Task details not found.",
      bookingRef: "Booking Ref",
      rateYourExperience: "Rate your experience",
      driverInformation: "Driver Information",
      saveDrivers: "Save Drivers",
      expiry: "Expiry",
      areYouSureDriver: "Are you sure you want to remove this driver from the",
      drivers: "Drivers",
      noDriverFound: "Sorry, no drivers found!",
      invoices: "Invoices",
      searchInvoiceId: "Search Invoice Id",
      unpaid: "Unpaid",
      paid: "Paid",
      void: "Void",
      invoiceId: "Invoice Id",
      invoiceDate: "Invoice Date",
      balanceDue: "Balance Due",
      dueDate: "Due Date",
      invoiceSummary: "Invoice Summary",
      invoice: "Invoice",
      sundry: "Sundry",
      addPayment: "Add Payment",
      customerPhoneNumber: "Customer Phone Number",
      invoiceReference: "Invoice Reference",
      period: "Period",
      invoiceVoidedBy: "Invoice Voided By",
      invoicePeriod: "Invoice Period",
      invoiceStatus: "Invoice Status",
      invoiceAmount: "Invoice Amount",
      amountDue: "Amount Due",
      generatedAt: "Generated At",
      vehicleRentalCharges: "Vehicle Rental Charges",
      refundable: "Refundable",
      date: "Date",
      thisIsTestCourtsey: "This is a test/courtesy",
      invoicesConsolidated: "Invoices Consolidated",
      payments: "Payments",
      exempted: "exempted",
      pleaseLoginFirst: "Please Login first",
      account: "Account",
      tracking: "Tracking",
      reports: "Reports",
      uploadImages: "Upload Images",
      updateVehicleState: "Update vehicle state",
      vehicleImage: "Vehicle Image",
      fuelStatus: "Fuel Status",
      batteryStatus: "Battery Status",
      odometerReading: "Odometer Reading",
      nextServiceDetails: "Next Service Details",
      serviceType: "Service Type",
      serviceStatus: "Service Status",
      appointmentDate: "Appointment Date",
      estdCompletionDate: "Estd. Completion Date",
      serviceProviderName: "Service Provider Name",
      serviceProviderAddress: "Service Provider Address",
      notesForDriver: "Notes for driver",
      exteriorDamages: "Exterior damages",
      interiorDamages: "Interior damages",
      generalChecks: "General checks",
      accessoriesChecks: "Accessories checks",
      chooseFuelLevel: "Choose fuel level",
      lastReported: "Last reported",
      circumstance: "Circumstance",
      title: "Title",
      damageKind: "Damage Kind",
      damageArea: "Damage Area",
      referenceNumber: "Reference Number",
      damageDetail: "Damage Detail",
      addImage: "Add Image",
      addImages: "Add Images",
      done: "Done",
      searchExistingDriver: "Search for existing driver",
      success: "Success",
      assignDriver: "Assign Driver",
      plate: "Plate",
      unassigned: "Unassigned",
      assigned: "Assigned",
      make: "Make",
      vehicleAppearOnceAssigned: "Vehicles will appear once assigned to you!",
      searchVehicle: "Search Vehicle",
      trackingHistoryHrs: "Tracking history (hours)",
      telemetryDevice: "Telemetry Device",
      lastLocation: "Last Location",
      latitude: "Latitude",
      longitude: "Longitude",
      forSelectedPeriod: "For Selected Period -",
      milesDriven: "Miles driven",
      engineHours: "Engine hours",
      fuelUsageLitres: "Fuel usage (Litres)",
      stoppagehours: "Stoppage hours",
      chargeStatus: "Charge Status",
      fuelUsage: "Fuel usage",
      batteryLevel: "Battery Level",
      speedLimit: "Speed limit",
      invalidEmailAddress: "Invalid email address",
      unableLoadCompanyDetails: "Unable to load company details",
      bookingConfirmationProgress: "Booking Confirmation in progress...",
      doNotHitBack:
        "Please do not hit back, cancel or close the browser. This process may take upto 2 mins..",
      summary: "Summary",
      addNew: "Add New",
      street: "Street",
      city: "City",
      regionState: "Region/State",
      country: "Country",
      zipPostalCode: "Zip/Postal code",
      cardAuthorizeNowButAmountLater:
        "Card will be authorised now but amount will be deducted when booking starts",
      saveThisCardForFutureInvoicesBooking:
        "Save this card to make payment for future invoices on this booking.",
      confirmBookingPayLater: "Confirm Booking, Pay Later",
      confirmBookingAndPayAtPickup:
        "Confirm booking now and pay at the time of pickup",
      bookingReferenceNumber: "Booking Reference Number",
      pickupDetails: "Pickup Details",
      dropoffDetails: "Dropoff Details",
      to: "To",
      bookingReference: "Booking Reference",
      invoiceStartDate: "Invoice Start Date:",
      invoiceEndDate: "Invoice End Date:",
      availableAtLocations: "Available at Locations",
      benefits: "Benefits",
      passportNumber: "Passport Number",
      enterPassportNumber: "Enter Your Passport Number",

      vehicleSwapRequest: "Vehicle Swap Request",
      checkVehicleAvailability: "Check Vehicle Availability",
      pleaseSelectDateAndSearch:
        "Please select date and click on search for vehicle availability",
      noVehicleFoundForSelectedDate: "No Vehicle found for the selected date",
      notes: "Notes",
      writeYourNoteHere: "Write your note here",
      updateRequest: "Update Request",
      generateRequest: "Generate Request",
      cancelRequest: "Cancel Request",
      operator: "Operator",
      you: "You",
      maximum: "Maximum",
      imagesAreAllowed: "images are allowed to upload.",
      dragAndDropFile: "Drag and drop a file or click",
      areAllowed: "are allowed",
      cancelBooking: "Cancel Booking",
      booked: "Booked",
      organisation: "Organisation",
      vatNumber: "VAT number",
      sort: "Sort",
      DELETE_DRIVER_DESCRIPTION: "Are you sure you want to delete the driver?",
      driverActions: {
        "Are you sure you want to delete the driver?":
          "Are you sure you want to delete the driver?",
        "Delete Driver": "Delete Driver",
      },
      currentInvoiceStatus: {
        PAID: "PAID",
        UNPAID: "UNPAID",
        VOID: "VOID",
        "PARTIALLY PAID": "PARTIALLY PAID",
        DRAFT: "DRAFT",
      },
      currentBookingStatus: {
        CANCELLED: "CANCELLED",
        COMPLETED: "COMPLETED",
        "CONFIRMATION IN PROCESS": "CONFIRMATION IN PROCESS",
        CONFIRMED: "CONFIRMED",
        "IN PROGRESS": "IN PROGRESS",
        QUOTE: "QUOTE",
        DRAFT: "DRAFT",
        "REQUIRES APPROVAL": "REQUIRES APPROVAL",
        DECLINED: "DECLINED",
      },
      minBookingDurationMessage:
        "The minimum booking duration is {{hours}} hours. Please adjust your pick-up or drop-off date and time accordingly.",
      maxBookingDurationMessage:
        "The maximum booking duration is {{days}} days. Please adjust your pick-up or drop-off date and time accordingly.",
      usevaletTypes: {
        Delivery: "Delivery",
        Collection: "Collection",
        "Delivery and Collection": "Delivery and Collection",
      },
      selectCollectionSlot: "Select Collection Slot",
      driverUnavailableNote:
        "Note: Driver is not available, please contact rental operator.",
      cancellationReasons: {
        "Requirement changed": "Requirement changed",
        Price: "Price",
        Other: "Other",
      },
      imagePreview: "Image Preview",
      markDamage: "Mark Damage",
      vehicleDamageImages: "Vehicle Damage Images",
      incidentDate: "Incident Date",
      incidentTime: "Incident Time",
      clear: "Clear",
      bookingStatus: "Booking Status",
      daysInBooking: "Days in booking",
      accumulatedDays: "accumulated days",
      endingThisMonth: "Ending this month",
      creditUtilisation: "Credit Utilisation",
      creditLimit: "Credit Limit",
      utilized: "Utilized",
      totalDrivers: "Total Drivers",
      vehiclesAllocated: "Vehicles Allocated",
      mileageOverview: "Mileage Overview",
      mileageLimitExited: "Mileage limit exited",
      approachingMileageLimits: "Approaching Mileage Limits",
      motReminders: "MOT Reminders",
      healthCheckReminders: "Health Check Reminders",
      totalMotTests: "Total MOT Tests",
      totalHealthCheckTests: "Total Health Checks Tests",
      failed: "Failed",
      serviceReminders: "Service Reminders",
      overdue: "Overdue",
      totalServiceReminders: "Total Service Reminders",
      createNewServiceRequest: "Create New Service Request",
      serviceDetails: "Service Details",
      selectedVehicle: "Selected Vehicle",
      serviceRequestSelectVehicle: "Select Vehicle",
      loadingVehicles: "Loading vehicles...",
      noActiveVehiclesFound: "No active vehicles found",
      addDetails: "Add Details",
      addItems: "Add Items",
      issueType: "Issue Type",
      issueTypePlaceholder: "e.g., Broken Lock",
      descriptionPlaceholder: "e.g., Front left door lock",
      uploaded: "Uploaded",
      additionalComments: "Additional Comments",
      additionalCommentsPlaceholder: "Add any additional information...",
      submitting: "Submitting...",
      submitRequest: "Submit Request",
      serviceRequestNote: "Your request will be reviewed by our service team. You'll receive a notification once it's approved or if additional information is needed.",
      serviceRequestDetails: "Service Request Details",
      createdDate: "Created Date",
      estimatedCost: "Estimated Cost",
      requestProgress: "Request Progress",
      issuesReported: "Issues Reported",
      issue: "Issue",
      imageAlt: "Image",
      serviceProvider: "Service Provider",
      appointment: "Appointment",
      at: "at",
      estimatedCompletion: "Estimated Completion",
      workToBeDone: "Work To Be Done",
      cost: "Cost",
      totalCost: "Total Cost",
      requestDeclined: "Request Declined",
      communication: "Communication",
      serviceTeam: "Service Team",
      noCommunicationYet: "No communication yet",
      addMessage: "Add a Message",
      askQuestionPlaceholder: "Ask a question or provide additional information...",
      sending: "Sending...",
      sendMessage: "Send Message",
      additionalInformationRequested: "Additional Information Requested",
      provideFollowingInformation: "Please provide the following information to help us process your request:",
      yourAnswer: "Your answer:",
      typeAnswerHere: "Type your answer here...",
      submitAnswers: "SUBMIT ANSWERS",
      approved: "Approved",
      serviceRequests: "Service Requests",
      scheduledServicesTitle: "Upcoming service which need to be requested",
      scheduledServicesBellAria: "View upcoming services to be requested",
      noScheduledServices: "No scheduled services",
      approveScheduledServiceSuccess: "Service approved successfully",
      requestChangesSuccess: "Change request sent for approval",
      requestChanges: "Request Changes",
      modifyServiceRequest: "Modify service request",
      modifyDetails: "Modify details",
      vehicleAndCategory: "Vehicle & category",
      cannotModify: "Cannot modify",
      appointmentDetails: "Appointment details",
      time: "Time",
      scheduledServiceReviewHint: "Please review the scheduled service. Approve if details are correct, or request changes.",
      approveService: "Approve service",
      jobSheet: "Job sheet",
      declined: "Rejected",
      lastUpdated: "Last updated",
      explainChangesPlaceholder: "Explain why you need these changes...",
      submitChanges: "Submit Changes",
      expenses: "Expenses",
      filters: "Filters",
      applyFilters: "Apply Filters",
      activeFilters: "Active Filters",
      newServiceRequest: "New Service Request",
      rowsPerPage: "Rows per page:",
      of: "of",
      moreThan: "more than",
      searchServiceRequestsPlaceholder: "Search by reference number, vehicle, or status...",
      selectOption: "Select an option",
      selectMultiple: "Select one or more options",
      uploadPhoto: "Upload Photo",
      view: "View",
      typeYourResponse: "Type your response",
      pleaseSelectServiceType: "Please select a service type",
      pleaseSelectServiceCategory: "Please select a service category",
      selectServiceType: "Select Service Type",
      serviceCategory: "Service Category",
      selectServiceCategory: "Select Service Category",
      unableToDetermineServiceBranch: "Unable to determine your service branch. Please try again later.",
      accidentDamageInformation: "Accident / Damage Information",
      documentUploads: "Document Uploads",
      adHoc: "Ad-Hoc",
      emergency: "Emergency",
      serviceQuestionnaire: "Service Questionnaire",
      serviceQuestionnaireDescription: "Provide a few extra details so our service team can prepare everything in advance.",
      selectServiceCategoryPrompt: "Select a service category to view the required questions for this service.",
      noServiceQuestionsForType: "No additional questions for this service type. You can continue with the request.",
      fileUploadGuidance: "Up to 5MB per file.",
      optionalServiceQuestion: "Optional question — answer if it helps our team.",
      requestCreated: "Request Created",
      underReview: "Under Review",
      inProgress: "In Progress",
      photo: "Photo",
      hiThere: "Hi there,",
      serviceRequestDeclinedMessage: "We've reviewed your service request, but it couldn't be approved right now.",
      whatWeNeed: "What we need:",
      declineReasonGeneric: "This may be due to missing details, service eligibility, or other approval conditions.",
      declineInstruction: "Please review your information and submit a new request once those updates are in place.",
      answered: "Answered",
      pendingAnswer: "Awaiting response",
      requiredField: "This response is required",
      questionsAnswered: "questions answered",
      readyToSubmitChanges: "Ready to submit updates",
      questionsUpToDate: "All responses are up to date",
      updateAnyAnswerToResubmit: "Update any answer above if you need to send new information.",
      answerTypeText: "Text",
      answerTypeYesNo: "Yes / No",
      answerTypeDropdown: "Dropdown",
      answerTypeMultiSelect: "Multi Select",
      answerTypeFileUpload: "Photo Upload",
      pendingApproval: "Pending Approval",
      awaitingMoreInformation: "Awaiting More Information",
      closed: "Closed",
      noServiceRequestsFound: "No service requests found",
      fleetAllocation: "Fleet Allocation",
      fleetAllocations: "Fleet Allocations",
      userAgreement: "User Agreement",
      organisationCode: "Organisation Code",
      serviceReference: "Service Reference",
      completionDate: "Completion Date",
      addTask: "Add Task",
      noTaskFound: "No tasks found. You can add tasks manually.",
      taskName: "Task Name",
      features: "Features",
      interiorFeatures: "Interior Features",
      exteriorFeatures: "Exterior Features",
      safetyAndTechnicalFeatures: "Safety And Technical Features",
      otherFeatures: "Other Features",
      privateHiresNo: "Private Hires No",
      pcoPrivateHiresHireDLNo: "PCO/Private Hire DL No",
      gender: "Gender",
      secondaryEmailAddress: "Secondary Email Address",
      secondaryPhoneNumber: "Secondary Phone Number",
      driverAge: "Driver Age",
      licenceDuration: "Licence Duration",
      penaltyPoints: "Penalty Points",
      insuranceClaimsHistory: "Insurance Claims History",
      pcoExpiryDate: "PCO Expiry Date",
      state: "State",
      selectBookingType: "Select Booking Type",
      selectBookingTypeDialog: "Please select one of the below booking types to proceed with the booking",
      regularBooking: "Regular Booking",
      contactlessBooking: "Contactless Booking",
      mode: "Mode",
      comments: "Comments",
      reviewBookingDetails: "Review booking details",
    },
    validation: {
      otpLengthMismatch: "OTP length must be 6 characters long",
      invalidOtp: "Invalid OTP",
      required: "{{field}} is required",
      billingEmailInvalid: "Please enter a valid Billing email.",
      billingEmailRequired: "Billing email is required.",
      phoneNumberRequired: "Phone number is required.",
      businessNameRequired: "Business name is required.",
      registrationNumberRequired: "Registration Number is required",
      vatRequired: "VAT/TAX Registration Number is required",
      accountNumberRequired: "Account Number is Required",
      registeredAddressRequired: "Registered Address is required.",
      registeredAddressCountryRequired: "Country is required.",
      registeredAddressStateRequired: "State is required.",
      registeredAddressCityRequired: "City is required,",
      registeredAddressStreetRequired: "Street is required.",
      tradingAddressRequired: "Trading Address is required.",
      tradingAddressCountryRequired: "Country is required.",
      tradingAddressStateRequired: "State is required.",
      tradingAddressCityRequired: "City is required.",
      tradingAddressStreetRequired: "Street is required.",
      contactEmailRequired: "Contact email is required.",
      firstNameRequired: "First name is required.",
      middleNameRequired: "Middle name is required.",
      lastNameRequired: "Last name is required.",
      addressRequired: "Address is required",
      locationRequired: "Location is required",
      emailIsRequired: "Email is required.",
      termsConditionsAccepted: "The terms and conditions must be accepted.",
      streetZipcodeRequired: "Street/zipcode is required",
      drivingLicenceNumberRequired: "Driving licence number is required",
      nationalInsuranceNumberRequired: "National insurance number is required",
      nationalityRequired: "Nationality is required",
      enterValidPhoneNumber: "Enter a valid phone number.",
      enterValidEmailAddress: "Please enter a valid email address",
      authorityRequired: "Authority is required",
      licenceNumberRequired: "{{licenceSyntax}} Number is required",
      licenceExpiryDateRequired: "{{licenceSyntax}} Expiry Date is required",
      expiryDateRequired: "Expiry Date is required",
      numberIsRequired: "Number is required",

      passwordLengthValidaion: "password length must be >=8",
      passwordContainUppercase:
        "Password must contain at least one uppercase letter",
      passwordContainLowercase:
        "Password must contain at least one lowercase letter",
      passwordContainOneNumber: "Password must contain at least one number",
      passwordContainSpecialCharacter:
        "Password must contain at least one special character",
      passwordMustMatch: "Passwords must match",
      atleastOneUppercase: "At least one Uppercase letter",
      atleastOneLowercase: "At least one Lowercase letter",
      atleastOneNumericalChar: "At least one Numerical character",
      atleastOneSpecialChar: "At least one Special character",
      pleaseEnterAValidEmail: "Please enter a valid email",
      driverNotFound: "Driver not found",
      batteryStatusNumber: "Battery Status must be a number",
      batteryStatusCantNegative: "Battery Status can't be negative",
      batteryStatusCantMoreHundred: "Battery Status can't be more than 100%",
      batteryStatusRequired: "Battery Status is required",
      odometerReadingMustNumber: "Odometer Reading must be a number",
      odometerReadingRequired: "Odometer Reading is required",
      odometerMustEqualOrHigherLast:
        "Odometer Reading must be equal or higher than the last reported reading",
      titleIsRequired: "Title is required.",
      damageKindIsRequired: "Damage Kind is required.",
      descriptionIsRequired: "Description is required.",
      damageImageIsRequired: "Damage image is required.",
      professionIsRequired: "Profession is required",
      passportNineCharacters: "Passport Number must be of 9 Characters",
      passportIsRequired: "Passport is Required",
      organisationCodeRequired: "Organisation Code is Required",
      userNotFound: "User not found",
      invalidPassword: "Invalid password",
      passwordLengthError: "Password length must be at least 8 characters long",
      customerPCONumberRequired: "Customer PCO/Private Hire DL No is required",
      genderRequired: "Gender is required",
    },
    misc: {
      edit: "Edit",
      logOut: "Log Out",
      licence: "Licence",
      cancel: "Cancel",
      save: "Save",
      exclusiveOffersAndDeals: "Exclusive Offers & Deals",
      allLocations: "All Locations",
      code: "Code",
      couponCode: "Coupon Code",
      enterCouponCode: "Enter your coupon code",
      apply: "Apply",
      couponApplied: "Coupon applied",
      couponDiscount: "Coupon discount",
      status: {
        PENDING: "Pending",
        APPROVED: "Approved",
        DECLINED: "Declined",
        IN_REVIEW: "IN_REVIEW",
      },
      delete: "Delete",
      create: "Create",
      signIn: "Sign In",
      loginViaSSO: "Login via SSO",
      select: "Select",
      back: "Back",
      error: "Error",
      yes: "Yes",
      no: "No",
      payConfirm: "Pay & Confirm",
      clickToAdd: "Click to add",
      close: "Close",
      download: "Download",
      selectCaps: "SELECT",

      forgotPassword: "Forgot password",
      pleaseNote: "Please Note",
      front: "Front",

      columnKey: {
        "#": "#",
        Particulars: "Particulars",
        Quantity: "Quantity",
        "Unit Price": "Unit Price",
        Duration: "Duration",
        "VAT/TAX": "VAT/TAX",
        Amount: "Amount",
        "Discounted Price": "Discounted Price"
      },
      columnLabelToKeyMap: {
        ITEM: "ITEM",
        DESCRIPTION: "DESCRIPTION",
        QUANTITY: "QUANTITY",
        "UNIT PRICE": "UNIT PRICE",
        DURATION: "DURATION",
        "DISCOUNTED PRICE": "DISCOUNTED PRICE",
        "VAT/TAX": "VAT/TAX",
        PRICE: "PRICE",
      },
      paymentColumnsKey: {
        Date: "Date",
        Amount: "Amount",
        "Mode Of Payments": "Mode Of Payments",
        Status: "Status",
      },
      consolidatedInvoicesColumnsKey: {
        "#": "#",
        "Invoice Reference Number": "Invoice Reference Number",
        "Vehicle Registration Numbers": "Vehicle Registration Number(s)"
      },
      buttonKey: {
        Rentals: "Rentals",
        Subscriptions: "Subscriptions",
        "Test Drive": "Test Drive",
        "Contract Hire": "Contract Hire",
      },
      subLabelKey: {
        "Book vehicle for hours and days": "Book vehicle for hours and days",
        "Subscribe vehicle for weekly/monthly":
          "Subscribe vehicle for weekly/monthly",
        "Test Drive our Premium Vehicles": "Test Drive our Premium Vehicles",
        "Contract Hire vehicle for weekly/monthly":
          "Contract Hire vehicle for weekly/monthly",
      },
      buttonTextKey: {
        "Subscribe Now": "Subscribe Now",
        "Book Now": "Book Now",
        "Contract Now": "Contract Now",
      },
      featuresKey: {
        "Flexible Leasing Options": "Flexible Leasing Options",
        "Choose the duration of your subscription as you go":
          "Choose the duration of your subscription as you go",
        "Change car anytime*": "Change car anytime*",
        "Home delivery option": "Home delivery option",
        "100% digital": "100% digital",
        "MOT and taxes": "MOT and taxes",
        "Without down payment": "Without down payment",
        "Vehicle Servicing": "Vehicle Servicing",
      },
      adjustmentColumnKey: {
        "#": "#",
        Amount: "Amount",
        "Adjusted To Invoice": "Adjusted To Invoice",
        "Adjusted At": "Adjusted At",
      },
      categoriesKey: {
        Knowledge: "Knowledge",
        Behavior: "Behavior",
        Punctuality: "Punctuality",
      },
    },
    snackBar: {
      couponApplied: "Coupon applied successfully",
      couponRemoved: "Coupon removed",
      customerInfoSaved: "Customer Information Saved",
      documentDeleted: "Document deleted successfully",
      documentDeleteFailed: "Failed to delete document",
      documentDeleteError: "Error deleting document",
      documentMarkedForDeletion:
        "Document marked for deletion. Changes will be applied when you save.",
      profileImageUploaded: "Profile Image uploaded successfully",
      uploadImageFormatError:
        "Please only upload .jpeg/.jpg/.png image format!",
      selectDocumentType: "Please select document type",
      selectExpiryDate: "Please select document expiry date",
      fileSizeExceeded50mb: "File size exceeded limit of 50MB",
      fileSizeExceeded5mb: "File size exceeded limit of 5MB",
      uploadSuccess: "Document uploaded successfully",
      invalidUploadFormat: "Please only upload PDF, PNG, JPG or JPEG files",
      selectExpiryDateUpload: "Please select an expiry date before uploading",
      ImageUploaded: "Image uploaded successfully",

      invalidFileType: "Invalid File Type. Allowed type: jpeg or png",
      costCenterInfoMissing: "Cost Center info missing!",
      selectedDriverAlreadyAdded: "Selected driver already added.",
      driverSavedSuccessfully: "Driver saved successfully.",
      additionalDriverCannotBeMore:
        "Additional Drivers cannot be more than Addon quantity",
      verificationStatusInReview: "Verification status is in review",
      verificationStatusPending: "Verification status is pending",
      quoteCreated: "Quote created",
      bookingCreated: "Booking created",
      pickUpLocationEmpty: "Pick-Up Location is empty",
      slotSelectionRequiredForNonNegotiable: "Slot selection is required.",
      protectionPlanMandatoryForPCOBooking:
        "Protection Plan is Mandatory for PCO booking",
      paymentAlreadyDone: "Payment already done",
      fileBeingGenerated: "File being generated, Please try after sometime",

      provideDeliveryAddress: "Please provide the delivery address!",
      noValidCreditReadingFound:
        "No valid credit reading found for this company.",
      noValidCreditScoreFound:
        "No valid credit score found. This may be due to over exceeded credit checks limit",

      atleastOneLicenceImage: "At least upload one licence image",
      licenceImageUploaded: "Licence Image Uploaded Successfully",
      maximumTwoImageLicence: "Maximum two images can be uploaded for licence!",
      imageUploadInProgress: "Please wait image upload in progress!",

      errorFetchingSignedUrl: "Error fetching signed URL",
      paymentFailed: "Payment has been failed, Please try again",
      paymentFailedReasonCardDetails:
        "Your payment has failed! Please check your card details or try again later.",
      maximumTwoImage: "Maximum two images can be uploaded for",

      cancelledSuccessfully: "cancelled successfully",
      selectReasonForCancel: "Please enter the reason to cancel",
      streetZipcodeRequired: "Street / Zipcode is required",
      feedbackSaved: "Thank you! Your feedback has been saved",
      driverAlreadyAdded: "Driver is already added!",
      driverRemoved: "Driver removed successfully",
      businessCustomerDriverDeleted: "Business customer driver delete.",
      errorInSavingData: "Error in saving data",
      damageInformationSaved: "Damage Information saved successfully.",
      errorSavingData: "Error in saving data",
      problemTelematicsData: "Problem loading telematics data",

      verificationRequestSent:
        "Verification request has been successfully sent.",
      vehicleStateUpdated: "Vehicle state updated",
      driverAdded: "Driver added.",
      businessCustomerCreated: "Business Customer created.",
      uploadOnlyImageFiles: "Please upload only image files (PNG, JPEG, JPG)",
      imageSizeExceed5MB: "Image size should not exceed 5MB",
      uploadFailed: "Upload failed",
      imagesUploadedSuccessfully: "Image(s) uploaded successfully!",
      failedToUploadImages: "Failed to upload images. Please try again.",
      pleaseSelectVehicle: "Please select a vehicle",
      pleaseFillInAllIssueDetails: "Please fill in all issue details",
      serviceRequestCreatedSuccessfully: "Service request created successfully! Reference:",
      errorCreatingServiceRequest: "Error creating service request",
      pleaseEnterNote: "Please enter a note",
      noteAddedSuccessfully: "Note added successfully",
      errorAddingNote: "Error adding note",
      pleaseAnswerAllRemainingQuestions: "Please answer all {{count}} remaining question{{plural}}",
      answersSubmittedSuccessfully: "Answers submitted successfully! Your request is now under review.",
      errorSubmittingAnswers: "Error submitting answers",
      serviceRequestNotFound: "Service request not found",
      errorLoadingServiceRequests: "Error loading service requests",
      oneVehicleForContactless: "Only one vehicle can be selected for contactless booking",
      oneVehicleForNonContactless: "Only contactless or smartcar vehicle can be selected for contactless booking",
      contactlessVehicleCannotBeSelected: "Contactless vehicle cannot be selected for regular bookings",
      bookingDetailsCreated: "Booking details created"
    },
  },
};